var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconfileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3962.7,1302H-3980v-22h11.009v6.285h6.29v-1.571h-4.718V1280h.461l4.257,4.252V1302h0Zm-10.435-12.573a4.571,4.571,0,0,0-1.458.982,4.57,4.57,0,0,0-.983,1.457,4.546,4.546,0,0,0-.361,1.784,4.547,4.547,0,0,0,.361,1.784,4.574,4.574,0,0,0,.983,1.457,4.569,4.569,0,0,0,1.458.982,4.561,4.561,0,0,0,1.786.36,4.562,4.562,0,0,0,1.785-.36,4.571,4.571,0,0,0,1.458-.982,4.57,4.57,0,0,0,.983-1.457,4.547,4.547,0,0,0,.361-1.784,4.546,4.546,0,0,0-.361-1.784,4.567,4.567,0,0,0-.983-1.457,4.573,4.573,0,0,0-1.458-.982,4.561,4.561,0,0,0-1.785-.36A4.561,4.561,0,0,0-3973.136,1289.428Zm1.786,4.576-1.941,1.939-.353-.353,1.94-1.939-1.94-1.939.353-.353,1.941,1.939,1.94-1.939.353.353-1.94,1.939,1.94,1.939-.353.353Z",
    transform: "translate(3983.351 -1279)",
    fill: "#D60D4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfileError);
export default __webpack_public_path__ + "static/media/icon.file-error.7f06fdfcca87dff77b1bf2a643998cf8.svg";
export { ForwardRef as ReactComponent };